<mat-dialog-content>
  Loading... Please wait
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</mat-dialog-content>
